<template>
  <div>
    <h4>监测数据</h4>
    <div v-if="display">
      <div v-for="(item,index) in equips" :key="index" style="display: flex" >
        <el-card style="height: 200px;width: 180px">
          <div>
            <P>
              {{item[0].memo}}
            </P>
          </div>
        </el-card>
        <el-card v-for="(it,i) in item" :key="i" style="width: 30%">
          <p>
            <span>
              设备号
            </span>
            <span>
              {{it.sn}}
            </span>
          </p>
          <house v-if="it.model==='com.iav.sinoverse.SinoverseDeviceHouse'"  :sn="it.sn"></house>
          <meteo :sn="it.sn" v-else-if="it.model==='com.iav.sinoverse.SinoverseDeviceMeteo'"></meteo>
          <irrige v-else :sn="it.sn"></irrige>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import { equipList, monitorData } from '@/api/demo.js'
  import House from "./House";
  import Meteo from "./Meteo";
  import Irrige from "./Irrige";
  export default {
    name: 'MonitorDemo',
    components:{ House, Meteo, Irrige},
    data() {
      return {
        equips:[],
        display:false
      }
    },
    watch: {
    },
    created() {
      let that=this
      setTimeout(()=>{
        that.display=true
      },500)
      this.equipData()
    },
    methods:{
      equipData(){
        equipList(null).then(data=>{
          let num=0
          for(let i=0;i<data.length;i++){
            if(i===0) {
              this.equips[0]=[]
              this.equips[num].push(data[i])
            }else if(i>0){
              // console.log(this.equips[num].memo,data[i].memo)
              if(this.equips[num][0].memo===data[i].memo){
                this.equips[num].push(data[i])
              }else{
                num++
                this.equips[num]=[]
                this.equips[num].push(data[i])
              }
            }
          }
        })
      }
    },
    mounted() {

      console.log('【↑↑↑】', this.$options.name)


    },
    beforeDestroy() {
      // console.log('【↓↓↓】', this.$options.name)
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitor/MonitorDemo/Demo.vue